import { useSuspenseQuery } from '@tanstack/react-query'
import { Outlet, createFileRoute, linkOptions } from '@tanstack/react-router'
import {
  FileCheckIcon,
  FileWarningIcon,
  FolderIcon,
  InfoIcon,
  ShieldIcon,
} from 'lucide-react'

import { queryCompanyGet } from '@api/company/company.queries'

import SwitchViewTabs from '../-components/switch-view-tabs'
import InsuredCompanyStats from './-components/insured-company-stats'

export const Route = createFileRoute(
  '/app/data/companies/$uuid/(mainPage)/insured',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { uuid } = Route.useParams()
  const company = useSuspenseQuery(queryCompanyGet(uuid))

  const routesData = [
    subRoutes['.'],
    { ...subRoutes.policies, count: company.data.stats.policiesCount },
    { ...subRoutes.coverages, count: company.data.stats.coveragesCount },
    { ...subRoutes.insistences, count: company.data.stats.insistencesCount },
    subRoutes.files,
  ]

  return (
    <>
      <InsuredCompanyStats companyUuid={uuid} />
      <div className="flex w-full flex-1 flex-col overflow-hidden">
        <SwitchViewTabs routes={routesData} />
        <div className="flex w-full flex-1 overflow-hidden p-6">
          <Outlet />
        </div>
      </div>
    </>
  )
}

const subRoutes = {
  '.': {
    name: '.',
    icon: InfoIcon,
    link: linkOptions({
      from: Route.fullPath,
      to: '/app/data/companies/$uuid/insured',
    }),
    displayName: 'data.companies.uuid.insured.tabs.information',
  },
  policies: {
    name: 'policies',
    icon: FileCheckIcon,
    link: linkOptions({
      from: Route.fullPath,
      to: '/app/data/companies/$uuid/insured/policies',
    }),
    displayName: 'data.companies.uuid.insured.tabs.policies',
  },
  coverages: {
    name: 'coverages',
    icon: ShieldIcon,
    link: linkOptions({
      from: Route.fullPath,
      to: '/app/data/companies/$uuid/insured/coverages',
    }),
    displayName: 'data.companies.uuid.insured.tabs.coverages',
  },
  insistences: {
    name: 'insistences',
    icon: FileWarningIcon,
    link: linkOptions({
      from: Route.fullPath,
      to: '/app/data/companies/$uuid/insured/insistences',
    }),
    displayName: 'data.companies.uuid.insured.tabs.insistences',
  },
  files: {
    name: 'files',
    icon: FolderIcon,
    link: linkOptions({
      from: Route.fullPath,
      to: '/app/data/companies/$uuid/insured/files',
    }),
    displayName: 'data.companies.uuid.insured.tabs.files',
  },
} as const
